import englishMessages from './languages/en-in.js';
import bahasaMessages from './languages/in';
import chineeseMessages from './languages/zh-CN';
import japaneseMessages from './languages/ja-JP';
import hindiMessages from './languages/hi-IN';
import spanishMexicanMessages from './languages/es-MX';
import thaiMessages from './languages/th-TH';
import portugueseMessages from './languages/pt-PT';
import frenchCanadianMessages from './languages/fr-CA';
import arabicMessages from './languages/ar';
import vietnamesMessages from './languages/vi-VN';
import italianMessages from './languages/it-IT';
import spanishMessages from './languages/es-ES';
import germanMessages from './languages/de-DE';
import dutchMessages from './languages/nl-NL';
import frenchMessages from './languages/fr-FR';
import greekMessages from './languages/el';
import croationMessages from './languages/hr';
import polishMessages from './languages/pl';
import getDeviceType from '../utils/getDeviceType';
import defaultlocale from './getDefaultLocale';

export const defaultLocale = defaultlocale;
const device = getDeviceType();

const webLanguageMessagesMapping = {
  [defaultLocale]: englishMessages,
  'en-US': englishMessages,
  'in': bahasaMessages,
  'zh': chineeseMessages,
  'vi': vietnamesMessages,
  'th': thaiMessages,
  'pt': portugueseMessages,
  'nl': dutchMessages,
  'ja': japaneseMessages,
  'it': italianMessages,
  'hi': hindiMessages,
  'fr-FR': frenchMessages,
  'fr-ca': frenchCanadianMessages,
  'es-MX': spanishMexicanMessages,
  'es-ES': spanishMessages,
  'de-DE': germanMessages,
  'ar': arabicMessages,
  'el': greekMessages,
  'hr': croationMessages,
  'pl': polishMessages
};

const coOyoLanguageMessagesMapping = {
  [defaultLocale]: englishMessages,
  'en-US': englishMessages,
  'in': bahasaMessages,
  'zh-cn': chineeseMessages,
  'vi': vietnamesMessages,
  'th': thaiMessages,
  'pt': portugueseMessages,
  'nl': dutchMessages,
  'ja': japaneseMessages,
  'it': italianMessages,
  'hi': hindiMessages,
  'fr-FR': frenchMessages,
  'fr-ca': frenchCanadianMessages,
  'es-MX': spanishMexicanMessages,
  'es-ES': spanishMessages,
  'de': germanMessages,
  'ar': arabicMessages
};

const languageMessagesMapping = device.isPhone ? coOyoLanguageMessagesMapping : webLanguageMessagesMapping;

export const languageMapping = {
  [defaultLocale]: true,
  'en-US': true,
  'vi': true,
  'ar': true,
  'es-ES': true,
  'pt': true,
  'in': true,
  'th': true,
  'es-MX': true,
  'ja': true,
  'de-DE': true,
  'it': true,
  'fr-ca': true,
  'zh': true,
  'el': true,
  'hr': true,
  'pl': true,
  'fr-FR': true,
  'nl': true
};

export const getMessageForLocale = locale => {
  let messages = languageMessagesMapping[defaultLocale];
  if (languageMessagesMapping[locale]) {
    messages = languageMessagesMapping[locale];
    if (locale !== defaultLocale) {
      Object.keys(englishMessages).forEach(key => {
        messages[key] = messages[key] || englishMessages[key];
      });
    }
  }
  return messages;
};
